import { render, staticRenderFns } from "./CatalogItem.vue?vue&type=template&id=322aa3ca&scoped=true&"
import script from "./CatalogItem.vue?vue&type=script&lang=ts&"
export * from "./CatalogItem.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogItem.vue?vue&type=style&index=0&id=322aa3ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322aa3ca",
  null
  
)

export default component.exports